import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FiservWebhookAddAccountComponent } from './add-account/fiserv-webhook.component';
import { FiservWebhookErrorResolutionComponent } from './error-resolution/fiserv-webhook.component';
import { FiservWebhooksRoutingModule } from './fiserv-webhooks.routing.module';

@NgModule({
    imports: [
        RouterModule,
        FiservWebhooksRoutingModule,
        CommonModule
    ],
    declarations: [
        FiservWebhookAddAccountComponent,
        FiservWebhookErrorResolutionComponent
    ]
})
export class FiservWebhooksModule { }
